import { Text, View, ScrollView} from 'react-native-web'
import React from 'react'
import { CardDetail } from '../../element/Card'
import { Title} from '../../element/Text'
import { Button} from '../../element/Button'
import {useState} from 'react';
import { ABLIST } from '../../List/AbilityList'
import  { Description1, Description2 } from '../PgMaker/PgMakerComponent/Sheets/SheetsComponent/Description'
import {doc, updateDoc} from 'firebase/firestore';
import { db } from '../../firebase/FirebaseConfig'
import { CharacterConfirm1, CharacterConfirm } from '../PgMaker/PgMakerComponent/Sheets/SheetsComponent/CharacterSave.js'
import { ArcaneList } from '../../List/ArcaneList'


const DetailSheet = ({navigation, route}) => {

const{item, Master}=route.params
const [flip, setFlip]=useState(false)
const [flip1, setFlip1]=useState(false)
const [flip2, setFlip2]=useState(false)
const Arcane=[...item.Arcane]
const Ability1=[...item.Abilita]


async function Confirm(){
  await updateDoc(doc(db, "personaggi", item.Key), {Mod:false,
                                                    Complete:true});
  setFlip1(!flip1)
  Back()}

async function ConfirmDeath(){
  await updateDoc(doc(db, "personaggi", item.Key), {Death:true});
  setFlip2(!flip2);
  Back()}

function Back (){
                  setFlip(false);
                  navigation.navigate('Home');}

function UpdateChar(){navigation.navigate('PgModify',{item})}

function Anagraphic(){
  return (
                 <View style={{width:'100%', height:'100%',alignItems:'center'}}>
                  <Title value={'Anagrafica'} color1={'#F9BA49'}/>
                  <View style={{width:'90%', height:'5%' ,flexDirection:'row', justifyContent:'space-evenly', marginTop:30, alignItems:'center', alignSelf:'center', borderColor:'#F9BA49', borderRadius:16, borderWidth:1.8, backgroundColor:'#252525',shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5,}}>
                    <Text style={{color:'#F9BA49',fontSize:18, fontWeight:'bold'}}>{'Nome:'}</Text>
                    <Text style={{color:'#F9BA49',fontSize:18, fontWeight:'bold'}}>{item.Name}</Text>
                  </View>
                  <View style={{width:'90%',height:'5%' , flexDirection:'row', justifyContent:'space-evenly', marginTop:30, alignItems:'center', alignSelf:'center',borderColor:'#F9BA49', borderRadius:16, borderWidth:1.8, backgroundColor:'#252525',shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5,}}>
                    <Text style={{color:'#F9BA49',fontSize:18, fontWeight:'600'}}>{'Tribù:'}</Text>
                    <Text style={{color:'#F9BA49',fontSize:18, fontWeight:'600'}}>{item.Tribe}</Text>
                  </View>
                  <View style={{width:'90%', height:'15%' , marginTop:30, alignItems:'center', alignSelf:'center',borderColor:'#F9BA49', borderRadius:16, borderWidth:1.8, backgroundColor:'#252525',shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5, padding:15}}>
                    <Text style={{color:'#F9BA49',fontSize:18, fontWeight:'600'}}>{'Segni particolari:'}</Text>
                    <Text style={{color:'#F9BA49',fontSize:18, fontWeight:'600', marginTop:15}}>{item.Sign}</Text>
                  </View>
                  <ScrollView style={{width:'90%',height:'30%',maxHeight:'35%', marginTop:30, alignSelf:'center',shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5,}} contentContainerStyle={{alignItems:'center',borderColor:'#F9BA49', borderRadius:16, borderWidth:1.8, backgroundColor:'#252525', height:'100%' }}>
                    <View style={{width:'100%', height:'100%', alignItems:'center', padding:15}}>
                      <Text style={{color:'#F9BA49',fontSize:18, fontWeight:'600'}}>{'Background:'}</Text>
                      <Text style={{color:'#F9BA49',fontSize:12, fontWeight:'400', padding:15, width:'80%'}}>{item.Background}</Text>
                    </View>
                  </ScrollView>
       {item.Mod? <View style={{width:'90%' ,flexDirection:'row', justifyContent:'space-evenly', marginTop:15, alignItems:'center', alignSelf:'center'}}>
          {flip1? <CharacterConfirm modalv={flip1} onPress={()=>{setFlip1(!flip1)}} onPress1={()=>{Confirm()}}/> : <Button color={'#F9BA49'} width={'45%'} text={'Conferma'} textColor={'#202020'} borderColor={'#202020'} onPress={()=>{setFlip1(!flip1)}}/>}
                  <Button color={'#202020'} width={'45%'}  text={'Modifica'}  textColor={'#F9BA49'} borderColor={'#F9BA49'} onPress={()=>{UpdateChar()}}/></View>:<></>}
       {item.Death? <></>: <View>{Master? <View style={{width:'90%' ,flexDirection:'row', justifyContent:'center', marginTop:15, alignItems:'center', alignSelf:'center'}}>
       
       {flip2? <CharacterConfirm1 modalv={flip2} onPress={()=>{setFlip2(!flip2)}} onPress1={()=>{ConfirmDeath()}}/> : <Button color={'red'} width={90} text={'Uccidi'} textColor={'#202020'} borderColor={'#202020'} onPress={()=>{setFlip2(!flip2)}}/> }</View>:<></>}</View>}</View>
       
       )}
        

function Ability(){
  return (
    <View style={{width:'100%', height:'100%',alignItems:'center'}}>
        <Title value={'Abilità'} color1={'#F9BA49'}/>
        <View style={{width:'90%',height:'60%', marginTop:30, alignItems:'center', alignSelf:'center', borderColor:'#F9BA49', borderRadius:16, borderWidth:1.8, backgroundColor:'#252525', paddingHorizontal:15, paddingBottom:15,shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5,justifyContent:'center'}}>
        {Ability1?.map((item)=> (<Description1 ability={ABLIST[ABLIST.findIndex((obj)=>obj.nome===item)].nome} size={'90%'} key={ABLIST[ABLIST.findIndex((obj)=>obj.nome===item)].id} title={ABLIST[ABLIST.findIndex((obj)=>obj.nome===item)].nome} type={ABLIST[ABLIST.findIndex((obj)=>obj.nome===item)].tipo} description={ABLIST[ABLIST.findIndex((obj)=>obj.nome===item)].descrizione} prerequisite={ABLIST[ABLIST.findIndex((obj)=>obj.nome===item)].prerequisiti}/>))}
        </View>
        {item.Mage? <View style={{width:'90%',height:'5%' , flexDirection:'row', justifyContent:'space-evenly', marginTop:15, alignItems:'center', alignSelf:'center',borderColor:'#F9BA49', borderRadius:16, borderWidth:1.8, backgroundColor:'#252525',shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5,}}>
        <Text style={{color:'#F9BA49',fontSize:18, fontWeight:'600'}}>{'Pilastro:'}</Text>
        <Text style={{color:'#F9BA49',fontSize:18, fontWeight:'600'}}>{item.Erinni}</Text>
        </View>:<></>}
        {item.Mage? <View style={{width:'90%',height:'15%' , flexDirection:'row', justifyContent:'space-evenly', marginTop:15, alignItems:'center', alignSelf:'center',borderColor:'#F9BA49', borderRadius:16, borderWidth:1.8, backgroundColor:'#252525',shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5,}}>
        <Text style={{color:'#F9BA49',fontSize:18, fontWeight:'600'}}>{'Arcani:'}</Text>
        <View style ={{width:'45%', height:'100%', alignItems:'center', justifyContent:'space-evenly'}}>
        {Arcane?.map((item)=>(<Description2 size={'100%'} Name={ArcaneList[ArcaneList.findIndex((obj)=>obj.Name === item)].Name} keys={ArcaneList[ArcaneList.findIndex((obj)=>obj.Name === item)].Id} erinni={ArcaneList[ArcaneList.findIndex((obj)=>obj.Name === item)].Erinni} description={ArcaneList[ArcaneList.findIndex((obj)=>obj.Name === item)].Description}/>))}
        </View>
        </View>:<></>}
    </View>
  )
}


return(
  <View style={{width:'100%', height:'100%',alignItems:'center',justifyContent:'center'}}>
    <CardDetail hsize={0.9} marginTop={30} icon1={true} icon2={true} onPress={()=>{Back()}} onPress1={()=>{setFlip(!flip)}} bottom={15} right={15}>
    {flip?<Ability/>:<Anagraphic/>}
  </CardDetail>
  </View>
);}
export default DetailSheet

